import React, { useEffect, useState } from "react";
import CustomWeb from "../../components/atoms/Webview";
import { Linking, Platform } from "react-native";
import LayoutContainer from "@components/layout/LayoutContainer";
import { replaceDeeplinkScheme } from "@utils/product/productValidators";
import Routes from "@navigations/Routes";
import { useNavigation } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { useNavigationMenuSlice } from "@redux/slices/navigationMenuSlice";
import { Spacer } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTheme } from "styled-components/native";
import styled from "styled-components/native";
import { css } from "styled-components/native";
import { useGetKnowiDashBoard } from "@apis/fetchKnowiDashboard";

const PagesScreen = ({ route }: any) => {
  const [iframeUrl, setIframeUrl] = useState("");
  const { navigationData } = useNavigationMenuSlice();
  const tabsData = navigationData?.sections?.filter(
    (item: any) => item?.name === Routes.PagesNavigator
  );

  const navigation = useNavigation();
  const { t } = useTranslation();
  const theme = useTheme();

  const knowiDashBoard = useGetKnowiDashBoard(
    !!route?.params?.widget_id && route?.params?.id === "analytics",
    route?.params?.widget_id
  );

  useEffect(() => {
    const generateWebViewUrl = () => {
      let mUrl = "";
      if (route?.params?.iframeUrl) {
        mUrl = route?.params?.iframeUrl;
        navigation.setOptions({
          title: t(route?.params?.headerTitle),
          ...(route?.params?.hideBackButton &&
            !theme.isMobile && {
              headerLeft: () => <></>,
            }),
        });
      } else if (route?.params?.id) {
        const tabData = tabsData.find(
          (item: any) => item?.params?.id === route?.params?.id
        );
        navigation.setOptions({
          title: t(tabData?.label),
          ...(route?.params?.hideBackButton &&
            !theme.isMobile && {
              headerLeft: () => <></>,
            }),
        });
        mUrl = tabData?.iframe_url ?? "";
      }
      setIframeUrl(mUrl);
    };
    if (route?.params?.id !== "analytics") {
      generateWebViewUrl();
    }
  }, [route, tabsData]);

  useEffect(() => {
    if (!knowiDashBoard.isFetching && knowiDashBoard.isSuccess) {
      if (route?.params?.id === "analytics") {
        const tabData = tabsData.find(
          (item: any) => item?.params?.id === route?.params?.id
        );
        navigation.setOptions({
          headerTitle: t(route?.params?.headerTitle || tabData?.label),
          ...(route?.params?.hideBackButton &&
            !theme.isMobile && {
              headerLeft: () => <></>,
            }),
        });
      }
      setIframeUrl(knowiDashBoard.data.data?.end_point);
    }
  }, [knowiDashBoard.isFetching, knowiDashBoard.isSuccess]);

  const handleOnMessage = (e: any) => {
    try {
      const data = JSON.parse(e);
      const payload = data.payload;

      switch (data.action) {
        case "deeplink":
          let deeplinkUrl = payload;
          if (Platform.OS !== "web") {
            deeplinkUrl = replaceDeeplinkScheme(
              deeplinkUrl,
              process.env.EXPO_PUBLIC_APP_SCHEME
            );
          }
          Linking.openURL(deeplinkUrl);
          break;
        case "external":
          Linking.openURL(payload);
          break;
        default:
          Linking.openURL(payload);
          break;
      }
    } catch (error) {
      //TODO handle error
    }
  };

  return (
    <ParentContainer isModal={route?.params?.isModal}>
      <LayoutContainer>
        <CustomWeb
          url={iframeUrl}
          showExtraBottomView={true}
          onMessage={(event: any) => {
            handleOnMessage(event?.nativeEvent?.data);
          }}
        />
        <Spacer
          size={
            theme.isMobile
              ? SpaceType.large
              : theme.isTablet
              ? SpaceType.Size_80
              : 0
          }
        />
      </LayoutContainer>
    </ParentContainer>
  );
};

const ParentContainer = styled.View<{ isModal: boolean }>`
  flex: 1;
  flex-basis: auto;
  ${({ isModal }) =>
    isModal &&
    css`
      height: 80vh;
    `}
`;

export default PagesScreen;
